import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { borderRadius, colors, spacing, subtleShadow } from 'ui/theme';
import { TOGGLE_SIZES } from './constants';

type WrapperProps = {
  disabled: boolean;
  isActive: boolean;
  onClick: (isActive?: boolean) => void;
  size: TOGGLE_SIZES;
};

type IndicatorProps = {
  isActive: boolean;
  size: TOGGLE_SIZES;
};

const INDICATOR_STYLES: Record<TOGGLE_SIZES, FlattenSimpleInterpolation> = {
  [TOGGLE_SIZES.LARGE]: css`
    width: ${spacing.plusQuarter};
    height: ${spacing.plusQuarter};
  `,
  [TOGGLE_SIZES.SMALL]: css`
    width: ${spacing.threeQuarter};
    height: ${spacing.threeQuarter};
  `,
};

const WRAPPER_STYLES: Record<TOGGLE_SIZES, FlattenSimpleInterpolation> = {
  [TOGGLE_SIZES.LARGE]: css`
    border-radius: ${borderRadius.full};
    height: ${spacing.plusHalf};
    width: ${spacing.x3};
  `,
  [TOGGLE_SIZES.SMALL]: css`
    border-radius: ${borderRadius.full};
    height: ${spacing.base};
    width: ${spacing.double};
  `,
};

const disabledToggleActiveRules = css`
  opacity: 0.5;
  background: ${colors.backgroundSuccess};
  cursor: not-allowed;
`;

const disabledToggleInactiveRules = css`
  background: ${colors.backgroundEmphasis};
  cursor: not-allowed;
`;

export const StyledToggle = styled.div`
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: space-between;
`;

export const Indicator = styled.div<IndicatorProps>`
  background: ${colors.backgroundPrimary};
  border-radius: ${borderRadius.full};
  margin: ${spacing.eighth};
  box-sizing: border-box;
  left: ${({ isActive }) => (isActive ? '50%' : 0)};
  top: 0;
  position: absolute;
  transition: all 0.15s;
  ${subtleShadow};
  ${({ size }) => INDICATOR_STYLES[size] || ``};
`;

export const Wrapper = styled.button<WrapperProps>`
  background: ${({ isActive }) => (isActive ? colors.backgroundSuccess : colors.backgroundStrong)};
  border: none;
  cursor: pointer;
  position: relative;
  transition: all 0.1s;

  &:hover {
    background: ${({ isActive }) =>
      isActive ? colors.backgroundSuccess : colors.backgroundStrongHover};
  }

  &:disabled,
  &:disabled:hover {
    ${({ isActive }) => (isActive ? disabledToggleActiveRules : disabledToggleInactiveRules)};

    ${Indicator} {
      background-color: ${({ isActive }) =>
        isActive ? colors.white : colors.backgroundStrongHover};
    }
  }

  ${({ size }) => WRAPPER_STYLES[size] || ``};
`;
